import {
  Card,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  ListItemIcon,
  ListItemText,
  MenuItem,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from "@material-ui/core";
import { Close, List } from "@material-ui/icons";
import {
  MasterEldDeviceDto,
  MasterEldDeviceUsageApiFactory,
  SingleDeviceUsageDetail,
} from "../../../common/data/service-proxies";
import { useCallback, useState } from "react";
import { Button, Loading, useTranslate } from "react-admin";
import { useAxiosInstance } from "../../../common/hooks/useAxiosInstance";
import { useTableHeaderStyles } from "../../assets/maintenance-dashboard/common";
import { parseISO } from "date-fns";

interface Props {
  record?: MasterEldDeviceDto;
}

interface EldUsageProps {
  data: SingleDeviceUsageDetail[];
}

const EldUsage = ({ data }: EldUsageProps) => {
  const tableClasses = useTableHeaderStyles();
  const translate = useTranslate();

  return (
    <TableContainer>
      <Table size="small">
        <TableHead>
          <TableRow className={tableClasses.tableHead}>
            <TableCell>Customer</TableCell>
            <TableCell>Status</TableCell>
            <TableCell>Since</TableCell>
            <TableCell>Vehicle</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {data.map((x) => (
            <TableRow className={tableClasses.row} key={x.startTime}>
              <TableCell>
                <Typography variant="body2">{x.tenantName}</Typography>
              </TableCell>
              <TableCell>
                <Typography variant="body2">
                  {translate(`appData.eldUsageTypes.${x.usageType}`, {
                    _: x.usageType,
                  })}
                </Typography>
              </TableCell>
              <TableCell>
                <Typography variant="body2">
                  {parseISO(x.startTime!).toLocaleString("en-US")}
                </Typography>
              </TableCell>
              <TableCell>
                <Typography variant="body2">{x.vehicleName ?? "-"}</Typography>
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export const ShowEldUsageMenuItem = ({ record }: Props) => {
  const [open, setOpen] = useState<boolean>(false);
  const [loading, setLoading] = useState<boolean>(false);
  const [data, setData] = useState<SingleDeviceUsageDetail[]>();
  const axios = useAxiosInstance();

  const handleDialogClose: React.MouseEventHandler<HTMLButtonElement> = (e) => {
    e.preventDefault();
    setOpen(false);
  };

  const handleDialogOpen = useCallback(() => {
    if (!axios) {
      return;
    }

    if (!record) {
      return;
    }

    setOpen(true);
    setLoading(true);
    MasterEldDeviceUsageApiFactory(undefined, axios.defaults.baseURL, axios)
      .apiAppMasterelddeviceusageSingleelddeviceusageGet(record.serialNumber!)
      .then((result) => {
        setData(result.data);
      })
      .finally(() => {
        setLoading(false);
      });
  }, [axios, record]);

  if (!record) {
    return null;
  }

  if (!record.serialNumber) {
    return null;
  }

  return (
    <>
      <MenuItem className="actions-menu-item" onClick={handleDialogOpen}>
        <ListItemIcon>
          <List />
        </ListItemIcon>
        <ListItemText>Show device usage history</ListItemText>
      </MenuItem>

      <Dialog fullWidth maxWidth="md" open={open} onClose={handleDialogClose}>
        <DialogTitle>
          Usage history for ELD device {record.serialNumber}
        </DialogTitle>
        <DialogContent>
          <Card>
            {loading || !data ? <Loading /> : <EldUsage data={data} />}
          </Card>
        </DialogContent>
        <DialogActions>
          <Button label="Close" onClick={handleDialogClose}>
            <Close />
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};
